import { render, staticRenderFns } from "./FileInputDinamicField.vue?vue&type=template&id=0ecfb5b2&"
import script from "./FileInputDinamicField.vue?vue&type=script&lang=js&"
export * from "./FileInputDinamicField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports